import {urls} from "./urls";
import {
    delete_,
    get,
    get_response,
    get_response_with_abort_controller,
    post,
    post_response, put
} from "../helper/request";
import querystring from "query-string";
import {notNull} from "./utils";
import cookie from "react-cookies";
import {globalUrlPrefix} from "./const";
import {AuthHeader} from "../configs/auth.token";

let searchAbortController = null;
let slideSearchAbortController = null;
let caseSearchAbortController = null;

export const getGlobalConfig = () => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_GLOBAL_CONFIGS
        get_response(url).then(response => resolve(response)).catch(err => reject(err))
    });
}

export const setGlobalConfig = (key, value) => {
    return new Promise((resolve, reject) => {
        let url = urls.SET_GLOBAL_CONFIGS;
        let data = {'key': key, 'value': value};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

/**
 * DO NOT MAKE THIS API CALL UNLESS YOU KNOW WHAT YOU ARE DOING
 * return format: {[{display_name: , name: , is_group: , users: [...]}, ...]}
 */
export const getGroupsForSharing = () => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_GROUPS_FOR_SHARING;
        get_response(url)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getListOfAccessForSharing = (slide_id) => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_LIST_OF_ACCESS_FOR_SHARING + '?slide_id=' + slide_id;
        get_response(url)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getListOfAccessForSharingCase = (case_id, show_only_assigned) => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_LIST_OF_ACCESS_FOR_SHARING_CASE + '?case_id=' + case_id + '&assigned_only=' + show_only_assigned;
        get_response(url)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const shareSlideToGroups = (slides, groups) => {
    if (!Array.isArray(slides)) slides = [slides]
    return new Promise((resolve, reject) => {
        let url = urls.SHARE_SLIDE_TO_GROUPS;
        let data = {'slides': slides, 'groups': groups};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const assignCaseToGroups = (cases, groups, only_share=false) => {
    if (!Array.isArray(cases)) cases = [cases]
    return new Promise((resolve, reject) => {
        let url = urls.ASSIGN_CASES_TO_GROUPS;
        let data = {'cases': cases, 'groups': groups, 'only_share': only_share, 'notify_assigned_users':cookie.loadAll().notify_assigned_users};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

/**
 * Revoke access to a slide for a group
 * @param slide_id (UUID) slide id to revoke access
 * @param group (string) group name to revoke access
 * @returns {Promise<unknown>}
 * @returns access_revoked (boolean) true if access revoked for the user
 */
export const revokeShareAccessSlide = (slide_id, group) => {
    return new Promise((resolve, reject) => {
        let url = urls.REVOKE_SHARE_ACCESS;
        let data = {'slide_id': slide_id, 'group': group};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const removeUserAccessToCase = (case_id, group, should_unassign=false) => {
    return new Promise((resolve, reject) => {
        let url = urls.REVOKE_ACCESS_TO_CASE;
        let data = {'case_id': case_id, 'group': group, 'unassign': should_unassign};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const generateAnonymousShareLink = (slides, link_expiration=null) => {
    if (!Array.isArray(slides)) slides = [slides]
    link_expiration = notNull(link_expiration) ? link_expiration.getTime() : null
    return new Promise((resolve, reject) => {
        const url = urls.GENERATE_ANONYMOUS_SHARE_LINK;
        const data = {'slides': slides, 'link_expiration': link_expiration, 'ip': window.location.origin + globalUrlPrefix};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getAllAnonymousShareLinks = () => {
    return new Promise((resolve, reject) => {
        const url = urls.GET_ALL_ANONYMOUS_SHARE_LINKS;
        get_response(url)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const deleteShareToken = (token_id) => {
    return new Promise((resolve, reject) => {
        const url = urls.DELETE_SHARE_TOKEN;
        delete_(`${url}${token_id}/`)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getListOfSharedSlidesFromToken = (token_id) => {
    return new Promise((resolve, reject) => {
        const url = urls.GET_LIST_OF_SHARED_SLIDES_FROM_TOKEN;
        get_response(`${url}${token_id}/`)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const addSlidesToCase = (case_id, slides) => {
    if (!Array.isArray(slides)) slides = [slides]
    let slide_ids = slides?.map(slide => slide.id)
    let slide_names = slides?.map(slide => slide.name)
    if (!Array.isArray(slide_ids)) slide_ids = [slide_ids]
    if (!Array.isArray(slide_names)) slide_names = [slide_names]
    return new Promise((resolve, reject) => {
        let url = urls.ADD_SLIDES_TO_CASE;
        let data = {'case_id': case_id, 'slide_ids': slide_ids, 'slide_names': slide_names};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getAllAccessPermissionCategories = () => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_ALL_ACCESS_PERMISSION_CATEGORIES;
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const createAccessPolicy = (policyName, organisation, permissions_names) => {
    return new Promise((resolve, reject) => {
        let url = urls.CREATE_ACCESS_POLICY;
        let data = {name: policyName, organisation: organisation, permissions_names: permissions_names}
        post_response(url, data)
            .then(response => resolve(response))
            .catch(err => reject(err))
    })
}

export const updatePermissionsInAccessPolicy = (data) => {
    return new Promise((resolve, reject) => {
        let url = urls.UPDATE_PERMISSIONS_IN_ACCESS_POLICY;
        post(url, data)
            .then(response => resolve(response))
            .catch(err => reject(err))
    })
}

export const updateMembersInAccessPolicy = (data) => {
    return new Promise((resolve, reject) => {
        let url = urls.UPDATE_MEMBERS_IN_ACCESS_POLICY;
        post(url, data)
            .then(response => resolve(response))
            .catch(err => reject(err))
    })
}

export const updateAccessPermissionsForUser = (data) => {
    return new Promise((resolve, reject) => {
        let url = urls.UPDATE_ACCESS_PERMISSIONS_FOR_USER;
        post(url, data)
            .then(response => resolve(response))
            .catch(err => reject(err))
    })
}

export const getAllAccessPermissions = (username) => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_ALL_ACCESS_PERMISSIONS + '?username=' + username;
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const getAllAccessPolicies = (organisation, page = -1, search='') => {
    return new Promise((resolve, reject) => {
        let url = encodeURI(`${urls.GET_ALL_ACCESS_POLICIES}?&organisation_name_or_id=${organisation}&p=${page}&q=${search}`)
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const getAccessPolicyPermissionsAndMembers = (organisation, policy) => {
    return new Promise((resolve, reject) => {
        let url = encodeURI(`${urls.GET_ACCESS_POLICY_PERMISSIONS_AND_MEMBERS}${organisation}/${policy}/`)
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const getUserAccessPermissionsAndPolicy = (username) => {
    return new Promise((resolve, reject) => {
        let url = encodeURI(`${urls.GET_USER_ACCESS_PERMISSIONS_AND_POLICY}${username}/`)
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const deleteAccessPolicy = (policy, organisation, retainPermissions = true) => {
    return new Promise((resolve, reject) => {
        let url = urls.DELETE_ACCESS_POLICY;
        let data = {name: policy, organisation: organisation, retainPermissions: retainPermissions}
        post(url, data).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const getDefaultPolicies = () => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_DEFAULT_POLICIES;
        get(url).then(response => resolve(response)).catch(err => reject(err))
    })
}

export const getReadStatusesForSlide = (slide_id) => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_READ_STATUSES_FOR_SLIDE + '?slide_id=' + slide_id;
        get_response(url)
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}

export const getDicomThumbnails = (slideId, is_barcode=false) => {
    return new Promise((resolve, reject) => {
        let src;
        if (is_barcode) {
            src = urls.GET_DICOM_BARCODE;
        } else {
            src = urls.GET_DICOM_PREVIEW;
        }
        src += '?slide_id=' + slideId;
        const xhr = new XMLHttpRequest();
        xhr.open('GET', src);
        // Authorization header not working with s3 buckets on cloud
        // It is made to create user level authorization for images
        // TODO: remove authorization if fetching from s3 bucket
        xhr.setRequestHeader('Authorization', AuthHeader());
        xhr.withCredentials = true;
        xhr.responseType = "arraybuffer";
        xhr.onload = function () {
            let arrayBuffer = new Uint8Array(this.response);
            // images accessed through an aws cloudfront distribution
            // return with a 403 HTTP status code if signed cookies aren't proper
            if (this.status === 403) {
                reject('err');
            }
            let blob = new Blob([arrayBuffer], {type: 'image/png'});
            resolve((window.URL || window.webkitURL).createObjectURL(blob));
        };
        xhr.addEventListener('error', function () {
            reject('err');
        });
        xhr.send();
    });
}

export const performAbortControllerTagAndSlideSearch = (value, cbUpdateSearchResults) => {
    if (searchAbortController){
        searchAbortController.abort();
    }
    searchAbortController = new AbortController();
    if (value.length >= 1 && value !== "#"){
        const encodedValue = value.replace('#', '%23')
        let url = urls.GET_SEARCH_TAG_RESULTS+'?search_term=' + encodedValue;
        get_response_with_abort_controller(url, searchAbortController.signal, true)
            .then(res => {
                cbUpdateSearchResults(res.data);
            })
            .catch(err => {
                console.log(err);
            });
    } else {
        cbUpdateSearchResults([]);
    }
}

export const performAbortControllerSlideSearch = (value, cbUpdateSlideSearchResults, isGammaViewOnly = false) => {
    if(slideSearchAbortController){
        slideSearchAbortController.abort();
    }
    slideSearchAbortController = new AbortController();
    if (value.length >= 1) {
        let url = urls.GET_SEARCH_SLIDE_RESULTS;
        if(isGammaViewOnly){
            url += `?search_term=${value}&gammaViewOnly=true`
        }else{
            url += '?search_term=' + value;
        }
        get_response_with_abort_controller(url, slideSearchAbortController.signal, true)
            .then(res => {
                cbUpdateSlideSearchResults(res.data);
            })
            .catch(err => {
                console.log(err);
            });
    } else {
        cbUpdateSlideSearchResults([]);
    }
}

export const performAbortControllerCaseSearch = (value, cbUpdateCaseSearchResults) =>  {
    if(caseSearchAbortController){
        caseSearchAbortController.abort();
    }
    caseSearchAbortController = new AbortController();
    if (value.length >= 1) {
        let url = urls.GET_SEARCH_CASE_RESULTS + '?search_term=' + value;
        get_response_with_abort_controller(url, caseSearchAbortController.signal, true)
            .then(res => {
                cbUpdateCaseSearchResults(res.data);
            })
            .catch(err => {
                console.log(err);
            });
    } else {
        cbUpdateCaseSearchResults([]);
    }
}

export const IHCAnalysisProfile = (action, data=null) => {
    return new Promise((resolve, reject) => {
        let url = urls.IHC_PROFILE;
        switch(action) {
            case "ADD":
                post(url, data).then(response => resolve(response))
                    .catch(err => reject(err))
                break;
            case "DELETE":
                if (data && data.id) {
                    url = `${url}${data.id}/`;
                    delete_(url)
                        .then(response => resolve(response))
                        .catch(err => reject(err));
                } else {
                    reject(new Error('ID is required for DELETE action'));
                }
                break;
            case "UPDATE":
                if (data && data.id) {
                    url = `${url}${data.id}/`;
                    put(url, data)
                        .then(response => resolve(response))
                        .catch(err => reject(err));
                } else {
                    reject(new Error('ID is required for UPDATE action'));
                }
                break;
            case "SET_DEFAULT":
                if (data && data.id) {
                    url = `${url}${data.id}/`;
                    put(url, {...data, is_default: true})
                        .then(response => resolve(response))
                        .catch(err => reject(err));
                } else {
                    reject(new Error('ID is required for UPDATE action'));
                }
                break;
            case "GET":
                get(url)
                    .then(response => resolve(response))
                    .catch(err => reject(err))
                break;
            default:
                reject(new Error('Invalid action type'));
                break;
        }
    });
}
